import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: "",
  tagsList: [],
  errMsg: null,
};

export const getLeadsAllTags = createAsyncThunk("leads/getLeadsAllTags", async (data, thunkAPI) => {
  try {
    const resp = await axios.get(`${process.env.REACT_APP_BASE_URL}api/leads/tags`, {
      headers: {
        Authorization: "Bearer " + localStorage.token,
        "Content-Type": "application/json",
      },
    });
    return resp.data;
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});

const tagsList = createSlice({
  name: "tagsList",
  initialState,
  extraReducers: {
    [getLeadsAllTags.pending]: (state) => {
      state.loading = true;
    },
    [getLeadsAllTags.fulfilled]: (state, action) => {
      state.loading = false;
      state.tagsList = action.payload.arTags;
    },
    [getLeadsAllTags.rejected]: (state, action) => {
      state.loading = false;
      state.errMsg = action.payload;
    },
  },
});

export default tagsList.reducer;
